import { SearchFieldV2 as SearchField, FormFieldV2 as FormField, DateRangeDropdownV2 } from '@/components/custom/erp';
import { accountListSearchColumns } from '@/constants/search-columns';
import { Label } from '@/components/ui/label';
import { TaiKhoan } from '@/types/schemas';
import { QUERY_KEYS } from '@/constants';

interface BasicInfoProps {
  searchFieldStates: {
    account: TaiKhoan | null;
    setAccount: (account: TaiKhoan | null) => void;
  };
}
export const ALLOWED_DEBT_ACCOUNT_CODE_PREFIXES = ['131', '138', '141', '244', '331', '338'];
const BasicInfo: React.FC<BasicInfoProps> = ({ searchFieldStates }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Ngày từ/đến:</Label>
          <DateRangeDropdownV2
            fromDateName='ngay_ct1'
            toDateName='ngay_ct2'
            toFieldClassName='w-40'
            fromFieldClassName='w-40'
          />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tài khoản:</Label>
          <SearchField<TaiKhoan>
            type='text'
            columnDisplay={'code'}
            displayRelatedField={'name'}
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/filter_by_code/?tk=${ALLOWED_DEBT_ACCOUNT_CODE_PREFIXES}`}
            searchColumns={accountListSearchColumns}
            value={searchFieldStates.account?.code || ''}
            relatedFieldValue={searchFieldStates.account?.name || ''}
            onRowSelection={searchFieldStates.setAccount}
            className='w-full'
          />
        </div>
        <div className='ml-40 flex items-center'>
          <FormField name='ct_vt' type='checkbox' />
          <Label className=''>Chi tiết theo vật tư, hàng hóa, dịch vụ</Label>
        </div>
        <div className='ml-40 flex items-center'>
          <FormField name='so_du' type='checkbox' />
          <Label>Tính số dư từng ngày</Label>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
